import AssignmentDetail from '@/views/AssignmentDetail'

export default [
    {
        path: '/organization/:organizationId/classes/:classId/assignments/:assignmentId',
        name: 'assignment-detail',
        component: AssignmentDetail,
        props: true,
        meta: {
            menuItemIndex: '3',
            title: 'Detail Assginment'
        }
    }
]
